var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 137,
    viewBox: "0 0 157 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_399",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 399",
    transform: "translate(-997 -2205)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_29",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 29",
    cx: 58.5,
    cy: 58.5,
    r: 58.5,
    transform: "translate(997 2205)",
    fill: "#7975fc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_30",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 30",
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    transform: "translate(1077 2265)",
    fill: "#7975fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightImage);
export default __webpack_public_path__ + "static/media/rightImage.c4a03e08dcff7dfc02085f6219344eaa.svg";
export { ForwardRef as ReactComponent };